import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import HorizontalSidebar from "./horizontalSidebar";
import { useTranslation } from "react-i18next";
import { all_routes } from "../../Router/all_routes";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { ChevronsLeft } from "feather-icons-react/build/IconComponents";
import { useSelector } from "react-redux";
import {
  GET_MENU,
  getApiBaseUrl,
} from "../../feature-module/AssetMgt/Config/Config";
// import { SidebarData1 } from "../../core/json/sidebar_dataone";

function setupAutoClearLocalStorage(timeoutMs) {
  let inactivityTimer;

  const resetTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      console.log("Clearing storage due to inactivity");
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/signin";
      // window.location.reload();
    }, timeoutMs);
  };

  const activityEvents = ["mousemove", "keydown", "scroll", "click"];

  activityEvents.forEach((event) => window.addEventListener(event, resetTimer));

  resetTimer(); // Start initial timer

  return () => {
    clearTimeout(inactivityTimer);
    activityEvents.forEach((event) =>
      window.removeEventListener(event, resetTimer)
    );
  };
}

const Sidebar = () => {
  const [SidebarData, setSidebarData] = useState([]);
  const [roleId, setRoleId] = useState("");
  const [inActivityTimeOut, setInActivityTimeOut] = useState(null); // in minutes

  useEffect(() => {
    const sessionRoleId = parseInt(sessionStorage.getItem("selectedRole"));
    const userData = JSON.parse(sessionStorage.getItem("user"));
    const timeOutMinutes = userData?.sessionTimeoutMinutes;

    setRoleId(sessionRoleId);
    if (!isNaN(timeOutMinutes)) {
      setInActivityTimeOut(timeOutMinutes);
    }
  }, []);

  useEffect(() => {
    if (!inActivityTimeOut) return;

    const timeoutMs = inActivityTimeOut * 60 * 1000;
    const cleanup = setupAutoClearLocalStorage(timeoutMs);

    return cleanup;
  }, [inActivityTimeOut]);

  useEffect(() => {
    if (!roleId) return;
    fetch(`${getApiBaseUrl()}${GET_MENU}?RoleId=${roleId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch menu");
        }
        return response.json();
      })
      .then((data) => {
        setSidebarData(data.ResultData);
      })
      .catch((error) => {
        console.error("Error fetching menu:", error);
      });
  }, [roleId]);

  const route = all_routes;

  const Location = useLocation();
  const { t } = useTranslation();

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const [toggle, SetToggle] = useState(false);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  useEffect(() => {
    const user = sessionStorage.getItem("user");

    if (!user) {
      sessionStorage.clear();
      window.location.href = "/signin";
    }
    if (!localStorage.getItem("GranulesIsloggedIn")) {
      sessionStorage.clear();
      window.location.href = "/signin";
    }
  }, []);

  const [isUserLoggedIn, setIsUserLoggedIn] = useState();

  useEffect(() => {
    const checkLoginStatus = () => {
      const isLoggedIn = localStorage.getItem("GranulesIsloggedIn") === "true";
      if (!isLoggedIn) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/signin"; // Optional redirect
      }
      setIsUserLoggedIn(isLoggedIn);
    };

    // Run on mount
    checkLoginStatus();

    // Listen for changes in any tab
    const handleStorageChange = (e) => {
      if (e.key === "GranulesIsloggedIn") {
        checkLoginStatus();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  console.log(isUserLoggedIn);
  console.log(roleId, "roleeeeeeee idddddd");
  // const navigate = useNavigate();

  const getAllValidLinks = (menu) => {
    const links = [];

    const traverse = (items) => {
      if (!Array.isArray(items)) return; // safety check

      for (const item of items) {
        if (item.link && item.link !== "#") {
          links.push(item.link);
        }

        // Recurse into submenuItems if present
        if (Array.isArray(item.submenuItems) && item.submenuItems.length > 0) {
          traverse(item.submenuItems);
        }
      }
    };

    traverse(menu);
    sessionStorage.setItem("validLinks", JSON.stringify(links));

    return links;
  };
  console.log(
    getAllValidLinks(SidebarData),
    "All valid links from SidebarData"
  );
  // Save links when SidebarData is fetched
  useEffect(() => {
    if (SidebarData && SidebarData.length > 0) {
      const allLinks = getAllValidLinks(SidebarData);

      // normalize to lowercase
      sessionStorage.setItem(
        "validLinks",
        JSON.stringify(allLinks.map((l) => l.toLowerCase()))
      );
    }
  }, [SidebarData]);

  // useEffect(() => {
  //   const storedLinks = JSON.parse(sessionStorage.getItem("validLinks")) || [];

  //   const currentPath = location.pathname.split("/").pop().toLowerCase();

  //   console.log("Comparing:", currentPath, "against", storedLinks);

  //   if (storedLinks.length > 0 && !storedLinks.includes(currentPath)) {
  //     navigate("/assetmgt/dashboard");
  //   }
  // }, [location.pathname]);

  return (
    <div>
      <div
        className={`sidebar ${toggle ? "" : "active"} ${
          expandMenus || dataLayout === "layout-hovered" ? "expand-menu" : ""
        }`}
        style={{ zIndex: "100" }}
        id="sidebar"
        onMouseLeave={expandMenu}
        onMouseOver={expandMenuOpen}
      >
        <>
          {/* Logo */}
          <div className="sidebar-logo">
            <Link to={route.assetmgtdashboard} className="logo logo-normal">
              <ImageWithBasePath src="assets/img/logo.png" alt="Img" />
            </Link>
            <Link to={route.assetmgtdashboard} className="logo logo-white">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Img" />
            </Link>
            <Link to={route.assetmgtdashboard} className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.png" alt="Img" />
            </Link>
            <Link
              id="toggle_btn"
              to="#"
              onClick={handlesidebar}
              // className="d-none"
            >
              {/* <i data-feather="chevrons-left" /> */}
              <ChevronsLeft className="feather-16" />
            </Link>
          </div>
          {/* /Logo */}
          <div className="modern-profile p-3 pb-0">
            <div className="text-center rounded bg-light p-3 mb-4 border">
              <div className="avatar avatar-lg online mb-3">
                <ImageWithBasePath
                  src="assets/img/customer/customer15.jpg"
                  alt="Img"
                  className="img-fluid rounded-circle"
                />
              </div>
              <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
              <p className="fs-12 mb-0">System Admin</p>
            </div>
            <div className="sidebar-nav mb-3">
              <ul
                className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
                role="tablist"
              >
                <li className="nav-item">
                  <Link className="nav-link active border-0" to="#">
                    Menu
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link border-0" to={route.chat}>
                    Chats
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link border-0" to={route.email}>
                    Inbox
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="sidebar-header p-3 pb-0 pt-2">
            <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
              <div className="avatar avatar-md onlin">
                <ImageWithBasePath
                  src="assets/img/customer/customer15.jpg"
                  alt="Img"
                  className="img-fluid rounded-circle"
                />
              </div>
              <div className="text-start sidebar-profile-info ms-2">
                <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
                <p className="fs-12">System Admin</p>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between menu-item mb-3">
              <div>
                <Link
                  to={route.assetmgtdashboard}
                  className="btn btn-sm btn-icon bg-light"
                >
                  <i className="ti ti-layout-grid-remove" />
                </Link>
              </div>
              <div>
                <Link to={route.chat} className="btn btn-sm btn-icon bg-light">
                  <i className="ti ti-brand-hipchat" />
                </Link>
              </div>
              <div>
                <Link
                  to={route.email}
                  className="btn btn-sm btn-icon bg-light position-relative"
                >
                  <i className="ti ti-message" />
                </Link>
              </div>
              <div className="notification-item">
                <Link
                  to={route.activities}
                  className="btn btn-sm btn-icon bg-light position-relative"
                >
                  <i className="ti ti-bell" />
                  <span className="notification-status-dot" />
                </Link>
              </div>
              <div className="me-0">
                <Link
                  to={route.generalsettings}
                  className="btn btn-sm btn-icon bg-light"
                >
                  <i className="ti ti-settings" />
                </Link>
              </div>
            </div>
          </div>
        </>
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu mb-5">
              <ul>
                {SidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array.push(item?.link);
                            });
                          }
                          return link_array;
                        });

                        title.links = link_array;
                        return (
                          <React.Fragment key={i}>
                            {" "}
                            <li
                              className={`submenu ${
                                !title?.submenu &&
                                Location.pathname === title?.link
                                  ? "custom-active-hassubroute-false"
                                  : ""
                              }`}
                            >
                              <Link
                                to={`assetmgt/${title?.link}`}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <i className={`ti ti-${title.icon} me-2`}></i>
                                <span className="custom-active-span">
                                  {t(title?.label)}
                                </span>
                                {title?.submenu && (
                                  <span className="menu-arrow" />
                                )}
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      <Link
                                        to={item?.link}
                                        className={`${
                                          item?.submenuItems
                                            ?.map((link) => link.link)
                                            .includes(Location.pathname) ||
                                          item?.link === Location.pathname
                                            ? "active"
                                            : ""
                                        } ${
                                          subsidebar === item?.label
                                            ? "subdrop"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          toggleSubsidebar(item?.label)
                                        }
                                      >
                                        {item?.label}
                                        {item?.submenu && (
                                          <span className="menu-arrow inside-submenu" />
                                        )}
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar === item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, subIndex) => (
                                            <li key={subIndex}>
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ===
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      {/* <CollapsedSidebar /> */}
    </div>
  );
};

export default Sidebar;
